namespace advisorop.services {
    `use strict`;

    export class AppTrackerApi {

        static readonly LIFECYCLE_NEW_ACCOUNT = 0;
        static readonly LIFECYCLE_GOAL_MODIFICATION = 1;

        readonly apiUrl = `/api/apptracker`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }

        // if archivedOnly is null, in that case return all
        getAppTrackerData(lifeCycleType: number, archivedOnly: boolean, filterByAdvisor: boolean = false, includeProposedAmount: boolean = false): ng.IHttpPromise<domains.IAppTrackerData[]> {
            return this.$http.get(`${this.apiUrl}/${lifeCycleType}?archivedOnly=${archivedOnly}&filterByAdvisor=${filterByAdvisor}&includeProposedAmount=${includeProposedAmount}`);
        }

        claimActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/claim`, null);
        }

        stealActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/steal`, null);
        }

        skipActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/skip`, null);
        }

        unClaimActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/unclaim`, null);
        }

        completeActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/complete`, null);
        }

        undoActivity(activityId: number): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/${activityId}/undo`, null);
        }

        updateNotes(lifeCycleViewModel: domains.AccountLifeCycleViewModel): ng.IHttpPromise<domains.AccountLifeCycleViewModel> {
            return this.$http.post(`${this.apiUrl}/activity/updatenotes`, lifeCycleViewModel);
        }
    }
    angular.module(Constants.ADVOP_SERVICES).service("appTrackerApi", AppTrackerApi);
}